<template>
  <div class="dem-dev-nova" v-if="demanda !== ''">
    <App-Demanda-Gerenciar :cpntDemanda="demanda" :cpntSelecionar="demDevSelecionarDemanda"></App-Demanda-Gerenciar>
  </div>
</template>

<style scoped>
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },

      cpntDemDevAlterarPagina: {
        required: true
      },
      cpntDemDevSetarStatusGeral: {
        required: true
      },
      cpntDemDevAtualizarDadosDemanda: {
        required: true
      }
    },
    components: {
      'App-Demanda-Gerenciar': () => import('@/components/demanda/Gerenciar/Demanda-Gerenciar.vue')
    },
    data: function () {
      return {
        demanda: ''
      }
    },
    mounted: function () {
      this.demDevSelecionarIniciar()
    },
    methods: {
      demDevSelecionarIniciar: function () {
        switch (this.cpntDemanda) {
          case 'dev_cliente':
            this.demanda = 'venda'
            break
            
          case 'dev_fornecedor':
            this.demanda = 'compra'
            break
        }
      },
      demDevSelecionarDemanda: function (valor) {
        // QUEBRA O SINCRONISMO DO VUE
        valor = JSON.parse(JSON.stringify(valor))

        // SETA O ID DO CONTATO ORIGINAL
        if ([ '', null, undefined ].indexOf(valor.id_con_original) !== -1) {
          valor.id_con_original = valor.id_con
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE A VENDA TEM UM CONTATO VALIDO
        if ([ '', null, undefined, '1', '2' ].indexOf(valor.id_con) !== -1) {
          // INICIA O PARAMETRO
          var params = { tipo: 'CONSULTAR_CONTATO', selecionar: true, titulo: 'Devolução em nome de:', tituloExplica: { mensagem: 'Esta venda foi feita para Consumidor Final (sem identificação) por isso é necessário indicar para qual Cliente será feita a Nota de Devolução e a disponibilização do Crédito.' } }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar, id, dados) => {
            if (atualizar === true) {
              // SETA O ID DO CONTATO ORIGINAL
              valor.id_con_original = valor.id_con

              // JUNTA OS VETORES E COLOCA OS VALORES COMO JOIN DO ID_CON
              for (var indexF in dados) {
                valor['id_con_' + indexF] = dados[indexF]
              }

              // SETA O ID DO CONTATO ATUALIZADO
              valor.id_con = dados.id

              // SETA NOVAMENTE OS DADOS DA VENDA SELECIONADA
              this.demDevSelecionarDemanda(valor)
            }
          }
          
          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        } else {
          // INICIA A VARIAVEL DE ROTA
          var router = ''

          // INICIA O FORMULARIO QUE SERÁ ENVIADO
          var formData = {}

          // VERIFICA QUAL DEMANDA SERÁ ENVIADOA
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              // SETA O NOME DA ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-dev-cliente'

              // SETA O CAMPO QUE DEVE ENVIAR
              formData.dem_venda = valor.cod_venda
              break

            case 'dev_fornecedor':
              // SETA O NOME DA ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-dev-fornecedor'

              // SETA O CAMPO QUE DEVE ENVIAR
              formData.dem_compra = valor.dem_compra
              break
          }

          // SETA O ID DO CONTATO DA DEVOLUÇÃO
          if ([ '', null, undefined, '1', '2' ].indexOf(valor.id_con_original) !== -1) {
            formData.id_con = valor.id_con
          }

          // CONVERTE O FORMULARIO EM LOT
          formData = { lot: [ formData ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, 'POST', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
            const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

            // PEGA A CHAVE REFERENCIA
            var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // console.log(retorno.ref[chaveD])
                // this.cpntDemDevAtualizarDadosDemanda(retorno.ref[chaveD])
                // PEGA O TIPO DA TELA QUE DEVE ABRIR
                var tipo = this.cpntDemanda === 'dev_fornecedor' ? 'dev_fornecedor_nova_numero' : 'dev_cliente_nova_numero'

                // REDIRECIONA A TELA
                this.$router.push({ name: tipo, params: { id: retorno.ref[chaveD] } })
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true)
                break
            }
          }, this.cpntDemDevSetarStatusGeral)
        }
      }
    },
    computed: {
      demDevMontarVetorPaginas: function () {
        return Object.values(this.paginas)
      },
      demDevMontarIndexPagina: function () {
        return Object.keys(this.paginas).indexOf(this.pagina)
      }
    }
  }
</script>